import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { Component } from 'react';
import classnames from 'classnames';
import { getUidStr } from '../utils/uid';
import { formClass } from './styles';
import { FormError } from '../utils/errors';
import { defaultProps } from '../utils/defaultProps';
import { docScroll } from '../utils/dom/document';
import { IGNORE_BIND, SUBMIT_TOPIC } from '../Datum/types';
import { FieldSetProvider } from './FieldSet';
import { isRTL } from '../config';
var emptyValue = {
  path: ''
};

var DefaultProps = _objectSpread2(_objectSpread2({}, defaultProps), {}, {
  scrollToError: false,
  throttle: 1000
});

var Form =
/*#__PURE__*/
function (_Component) {
  _inherits(Form, _Component);

  var _super = _createSuper2(Form);

  function Form(props) {
    var _this;

    _classCallCheck(this, Form);

    _this = _super.call(this, props);
    _this.locked = void 0;
    _this.id = void 0;
    _this.element = void 0;
    _this.validating = void 0;
    _this.form = void 0;
    _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_this));
    _this.handleSubmit = _this.handleSubmit.bind(_assertThisInitialized(_this));
    _this.handleReset = _this.handleReset.bind(_assertThisInitialized(_this));
    _this.locked = false;
    _this.id = "form_".concat(getUidStr());
    _this.form = {
      getValue: function getValue() {
        return _this.props.datum.getValue();
      },
      validate: function validate() {
        return _this.props.datum.validate();
      },
      validateFields: function validateFields(fields) {
        return _this.props.datum.validateFields(fields)["catch"](function () {});
      },
      validateFieldsWithError: function validateFieldsWithError(fields) {
        return _this.props.datum.validateFields(fields);
      },
      clearValidate: function clearValidate() {
        _this.props.datum.validateClear();
      },
      submit: function submit() {
        var withValidate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        if (withValidate) _this.handleSubmit();else {
          var activeEl = document.activeElement;
          if (activeEl) activeEl.blur();
          if (_this.props.onSubmit) _this.props.onSubmit(_this.props.datum.getValue());
          if (activeEl) activeEl.focus();
        }
      },
      reset: function reset() {
        _this.handleReset();
      }
    };
    return _this;
  }

  _createClass(Form, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var formRef = this.props.formRef;

      if (formRef) {
        if (typeof formRef === 'function') {
          formRef(this.form);
        } else {
          formRef.current = this.form;
        }
      }

      this.setStatus();

      if (this.element) {
        this.element.addEventListener('submit', this.handleSubmit);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.setStatus();
      if (prevProps.error !== this.props.error) this.props.datum.resetFormError(this.props.error);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.datum.formUnmount = true;

      if (this.element) {
        this.element.removeEventListener('submit', this.handleSubmit);
      }
    }
  }, {
    key: "setStatus",
    value: function setStatus() {
      var _this$props = this.props,
          disabled = _this$props.disabled,
          pending = _this$props.pending,
          setFormStatus = _this$props.setFormStatus;
      if (!setFormStatus) return;
      var status = disabled === true ? 'disabled' : '';
      if (pending === true) status = 'pending';
      setFormStatus(status);
    }
  }, {
    key: "bindElement",
    value: function bindElement(el) {
      this.element = el;
    }
  }, {
    key: "scrollToError",
    value: function scrollToError(err) {
      var _this$props2 = this.props,
          scrollToError = _this$props2.scrollToError,
          onError = _this$props2.onError;

      if (scrollToError !== false) {
        var el = this.element.querySelector(".".concat(formClass('invalid')));

        if (el) {
          el.scrollIntoView();
          if (el.focus) el.focus();
        }

        if (typeof scrollToError === 'number' && scrollToError !== 0) {
          docScroll.top -= scrollToError;
        }
      }

      if (onError) onError(err);
      if (err instanceof Error && !(err instanceof FormError)) throw err;
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(e) {
      var _this2 = this;

      if (e) {
        e.preventDefault();
      }

      if (e && e.target.getAttribute('id') !== this.id) return;
      if (this.validating || this.locked) return;
      this.validating = true; // prevent duplicate submit

      this.locked = true;
      setTimeout(function () {
        _this2.locked = false;
      }, this.props.throttle);
      var _this$props3 = this.props,
          datum = _this$props3.datum,
          onSubmit = _this$props3.onSubmit;
      var activeEl = document.activeElement;
      if (activeEl) activeEl.blur();
      datum.dispatch(SUBMIT_TOPIC);
      setTimeout(function () {
        datum.validate(IGNORE_BIND).then(function () {
          _this2.validating = false; // @ts-ignore

          var detail = e && e.nativeEvent && e.nativeEvent.detail;
          if (onSubmit) onSubmit(datum.getValue(), detail, e);
          if (activeEl) activeEl.focus();
        })["catch"](function (err) {
          _this2.validating = false; // wait for render complete

          setTimeout(_this2.scrollToError.bind(_this2, err));
        });
      }, 10);
    }
  }, {
    key: "handleReset",
    value: function handleReset() {
      var _this$props4 = this.props,
          datum = _this$props4.datum,
          onReset = _this$props4.onReset;
      datum.reset();
      if (onReset) onReset();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          layout = _this$props5.layout,
          style = _this$props5.style,
          inline = _this$props5.inline,
          disabled = _this$props5.disabled,
          datum = _this$props5.datum,
          rules = _this$props5.rules,
          pending = _this$props5.pending;

      if (datum && rules && datum.rules !== rules) {
        datum.rules = rules;
      }

      var className = classnames(formClass('_', layout, (disabled || pending) && 'disabled', inline && 'inline', isRTL() && 'rtl'), this.props.className);
      return (
        /*#__PURE__*/
        React.createElement("form", {
          ref: this.bindElement,
          className: className,
          id: this.id,
          style: style,
          onReset: this.handleReset
        },
        /*#__PURE__*/
        React.createElement(FieldSetProvider, {
          value: emptyValue
        }, this.props.children))
      );
    }
  }]);

  return Form;
}(Component);

Form.defaultProps = DefaultProps;
export default Form;